import React, { useState } from 'react'
import { Modal, Paper, Typography, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { toastAlert } from '../../../utils/AlertContext';
import { postSendEmailURL } from "../../../utils/ConstantsURL";

export const SendEmail = ({ token, open, close, refresh, idDocument }) => {
    const [loading, setLoading] = useState(false);
      
    const handleSendEmail = async () => {
      setLoading(true);
      try {
        const response = await fetch(postSendEmailURL(idDocument, "user"), {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
    
        if (!response.ok) {
          toastAlert('Error al enviar el email', 'error');
          setLoading(false);
          return;
        }
        toastAlert('Email enviado correctamente', 'success');
        setLoading(false);
        close();
        refresh();
      } catch (error) {
        toastAlert('Error al enviar el email: ' + error, 'error');
        setLoading(false);
      }
    };
  
    return (
      <Modal open={open} onClose={close}>
          <Paper
              elevation={2}
              style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              padding: '20px',
              display: 'flex',
              flexDirection: 'column',
              outline: 'none',
              }}
          >
              <Typography variant="h6" style={{ margin: '10px 0' }}>
                ¿Desea enviar un correo electrónico? Esta acción se completará al presionar Confirmar.
              </Typography>
              <div style={{ display: 'flex', justifyContent: 'end' }}>
                <Button variant="contained" onClick={close} color="error">
                    Cancelar
                </Button>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  style={{ marginLeft: '20px' }}
                  onClick={handleSendEmail}
                  loading={loading}
                >
                  Confirmar
                </LoadingButton>
              </div>
          </Paper>
      </Modal>
    );
}
